import { connect } from 'react-redux';

import LogoutPage from './LogoutPage';
import { actionCreators } from '../../dux/user';

const mapDispatchToProps = {
  logOutHandler: actionCreators.logOut,
};

export default connect(null, mapDispatchToProps)(LogoutPage);
